import { Component, Input, OnChanges } from '@angular/core';
import {AlertGeoJson, WeatherWarningsLayerService} from '../services/weather-warnings-layer.service';
import {ToastService} from '../../../services/toast.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-alert-info-window-content',
  templateUrl: './alert-info-window-content.component.html',
  styleUrls: ['./alert-info-window-content.component.scss'],
  imports: [MatProgressSpinner],
})
export class AlertInfoWindowContentComponent implements OnChanges {
  @Input() oid: string;
  @Input() title: string;
  isLoading = true;

  alert: AlertGeoJson;

  constructor(
    private weatherWarningsService: WeatherWarningsLayerService,
    private toast: ToastService
  ) {}

  ngOnChanges() {
    this.weatherWarningsService
      .getAlert(this.oid)
      .then(alert => {
        this.alert = alert;
        this.isLoading = false;
      })
      .catch(message => {
        console.log(message);
        this.toast.long('Failed to load data from weather.gov!');
        this.isLoading = false;
      });
  }
}
